/* eslint-disable eslint-comments/disable-enable-pair */
import { CircularProgress } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';

import { Panel } from '../../panel/Panel.component';
import styles from './RequestingSignatureModal.module.css';

const useStyles = makeStyles(() =>
  createStyles({
    loading: {
      color: '#FCD559',
    },
  }),
);

const RequestingSignature: React.FC = () => {
  const classes = useStyles();
  return (
    <Panel
      title="Requesting Signature"
      bodyClassName="flex flex-col justify-center items-center"
    >
      <CircularProgress className={classes.loading} size={100} />
      <div className={styles.title}>Waiting for Metamask...</div>
      <div className={styles.body}>
        Please accept the signature request in MetaMask to connect your
        smart-wallet.
      </div>
    </Panel>
  );
};

export const RequestingSignatureModal = () => () => {
  return <RequestingSignature />;
};
